/**
 * PHQ-9 / GAD-7 표준 해석 구간 (샘플 화면 공용)
 * - 구간 경계(5/10/15/20점)는 개인 상세의 점수 색상(getScoreColor) 기준과 같습니다.
 */
export const PHQ_BANDS = [
  { min: 20, label: "심한 우울증" },
  { min: 15, label: "중간~심한 우울증" },
  { min: 10, label: "중간 정도 우울증" },
  { min: 5, label: "가벼운 우울증" },
  { min: 0, label: "정상" },
];

export const GAD_BANDS = [
  { min: 15, label: "심한 불안" },
  { min: 10, label: "중간 정도 불안" },
  { min: 5, label: "가벼운 불안" },
  { min: 0, label: "정상" },
];

export const getBandLabel = (bands, score) => bands.find((band) => score >= band.min)?.label ?? "-";

// 개인 상세(UserDetailView)의 getScoreColor와 같은 점수 구간별 색상
export const getScoreColor = (type, score) => {
  if (typeof score !== "number") return "#e5e7eb";
  if (type === "phq") {
    if (score >= 20) return "#ff3b30";
    if (score >= 15) return "#f6788b";
    if (score >= 10) return "#ffa24d";
    if (score >= 5) return "#ffd561";
    return "#929292";
  }
  if (score >= 15) return "#ff3b30";
  if (score >= 10) return "#ffa24d";
  if (score >= 5) return "#ffd561";
  return "#929292";
};
